<script>
  export let open = false;
  export let mode = 'bottom'; // bottom | anchor | center
  export let anchorRect = null;

  const POPUP_WIDTH = 200;
  const POPUP_HEIGHT = 180;
  const GAP = 8;
  const MARGIN = 8;

  let position = { top: 0, left: 0 };

  function close() {
    open = false;
  }

  function calcPosition() {
    if (!anchorRect) return { top: 0, left: 0 };

    const vw = window.innerWidth;
    const vh = window.innerHeight;

    let left = anchorRect.left + anchorRect.width / 2 - POPUP_WIDTH / 2;

    left = Math.max(MARGIN, left);
    left = Math.min(left, vw - POPUP_WIDTH - MARGIN);

    const spaceBelow = vh - anchorRect.bottom;
    const spaceAbove = anchorRect.top;

    let top;
    if (spaceBelow >= POPUP_HEIGHT + GAP) {
      top = anchorRect.bottom + GAP;
    } else if (spaceAbove >= POPUP_HEIGHT + GAP) {
      top = anchorRect.top - POPUP_HEIGHT - GAP;
    } else {
      top = Math.max(MARGIN, vh - POPUP_HEIGHT - MARGIN);
    }

    return { top, left };
  }

  $: if (open && mode === 'anchor' && anchorRect) {
    position = calcPosition();
  }
</script>

{#if open}
  <div class="fixed inset-0 z-50">
    <!-- overlay -->
    <div class="absolute inset-0 bg-black/40" on:click={close}></div>

    {#if mode === 'bottom'}
      <!-- BOTTOM SHEET -->
      <div
        class="absolute bottom-0 left-0 right-0
               bg-white rounded-t-2xl
               max-h-[90dvh] overflow-hidden
               p-4 pb-6
               animate-slide-up">
        <slot />
      </div>
    {:else if mode === 'anchor' && anchorRect}
      <!-- ANCHOR -->
      <div
        class="absolute bg-white rounded-xl shadow-lg
               p-3 animate-scale-in"
        style="
          top: {position.top}px;
          left: {position.left}px;
          width: {POPUP_WIDTH}px;
        ">
        <slot />
      </div>
    {:else if mode === 'center'}
      <!-- 🎯 CENTER MODAL -->
      <div
        class="popup-center-shell bg-white rounded-2xl shadow-xl
               animate-scale-in-center">
        <slot />
      </div>
    {/if}
  </div>
{/if}

<style>
  @keyframes slide-up {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }

  @keyframes scale-in {
    from {
      transform: scale(0.95);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  @keyframes scale-in-middle {
    from {
      transform: translate(-50%, -50%) scale(0.96);
      opacity: 0;
    }
    to {
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
    }
  }

  .animate-slide-up {
    animation: slide-up 0.25s ease-out;
  }

  .animate-scale-in {
    animation: scale-in 0.15s ease-out;
  }

  .animate-scale-in-center {
    animation: scale-in-middle 0.15s ease-out;
  }

  .popup-center-shell {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: 90vw; /* 👈 cách 5% mỗi bên */
    max-height: 90vh; /* 👈 cách 5% trên dưới */

    overflow: hidden;
  }
</style>
